<div class="card">
  <!-- card header -->
  <div class="card-head">
    <img src="../../../../../../assets/images/person-rounded.svg" alt="user" />
    <span>{{comment?.studentName}}</span>
  </div>

  <!-- comment -->
  <div class="comment ellipsis">
    <span>" {{comment?.comment}} "</span>
  </div>
</div>
